import { ReactElement } from "react"
import { Outlet } from "react-router"
import { HealthCheckWarningBanner } from "@/components/health-check-warning-banner"
import { UpdateVersionBanner } from "@/components/update-version-banner"
import { UserWarningBanner } from "@/components/user-warning-banner"
import { SubNavigation } from "@/layouts/admin"
import { Navbar } from "@/layouts/navbar"
import { InboundCallBanner } from "@/modules/patients/components/inbound-call-banner"

const DefaultLayoutOutlet = (props: { children?: ReactElement; isAdminRoute: boolean }) => {
  return (
    <div className="flex h-screen w-screen flex-col">
      <HealthCheckWarningBanner />
      <UserWarningBanner />
      <UpdateVersionBanner />
      <InboundCallBanner />
      <div className="grid-cols-auto-1fr grid h-full grid-rows-1 overflow-hidden">
        <Navbar subNavigation={props.isAdminRoute ? <SubNavigation /> : undefined}>{props.children}</Navbar>
        <main className="grid-rows-auto-1fr bg-background-subdued grid">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export { DefaultLayoutOutlet }
